var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.052,
    height: 9.654,
    viewBox: "0 0 19.052 9.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#45338c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-286.528,1345.254a6.536,6.536,0,0,1-1.338-.219c-.209-.083-.367-.383-.474-.619-.278-.611-.517-1.239-.766-1.862a2.687,2.687,0,0,1-.186-.565c-.042-.267-.032-.542-.057-.813a.611.611,0,0,1,.262-.621c.334-.261.583-.679,1.088-.46a4.007,4.007,0,0,1,.7.465,2.3,2.3,0,0,1,.489.4,1.47,1.47,0,0,1,.316.62c.073.439.2.573.642.431a4.648,4.648,0,0,0,1.265-.543,19.068,19.068,0,0,1,3.049-1.5c.646-.3,1.279-.631,1.926-.932.791-.368,1.592-.715,2.386-1.078.507-.231,1.009-.474,1.513-.713.027-.012.05-.034.077-.043q1.463-.523,2.926-1.043c.4-.143.81-.277,1.211-.427.689-.257,1.082-.176,1.016.561a1.758,1.758,0,0,0,.113.466c.139.659.08.858-.486,1.186-.617.358-1.264.666-1.9,1-.748.4-1.484.813-2.242,1.188-.671.332-1.372.6-2.046.93-.951.463-1.885.96-2.833,1.429-.174.086-.4.072-.568.163-.24.128-.438.335-.677.466-.395.217-.806.4-1.214.6-.746.349-1.477.74-2.248,1.023A18.76,18.76,0,0,1-286.528,1345.254Z",
    transform: "translate(289.355 -1335.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick6);
export default __webpack_public_path__ + "static/media/tick-6.7078a0eca25613da0f0dca5f046edb33.svg";
export { ForwardRef as ReactComponent };